import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { NgTableComponent } from '../tableModel/ng-table.component';
import { NgTableFilteringDirective } from '../tableModel/ng-table-filtering.directive';
import { NgTablePagingDirective } from '../tableModel/ng-table-paging.directive';
import { NgTableSortingDirective } from '../tableModel/ng-table-sorting.directive';
import { Model } from '../model/model.class';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-table-template',
    templateUrl: './table.template.component.html',
    providers: [DatePipe]
})
export class TableTemplateComponent implements OnInit {
 
    @Input() public data: Array<Model>;
    @Input() public columns: Array<any>;

    public rows: Array<Model> = [];
    public page = 1;
    public itemsPerPage = 10;
    public maxSize = 5;
    public numPages = 1;
    public length = 0;

    public config: any;

    public constructor(public router: Router, public userService: UserService, private datePipe: DatePipe) { }

    public ngOnInit(): void {
        this.data = this.data.filter(function (e) {
            return e != null;
        })
        this.length = this.data.length;
        this.config = {
            paging: this.length > this.itemsPerPage,
            sorting: { columns: this.columns },
            filtering: { filterString: '' },
            className: ['table-striped', 'table-bordered']
        };
        this.onChangeTable(this.config);
    }

    public ngOnChanges(changes: SimpleChanges) {
        this.data = changes.data.currentValue;
        this.ngOnInit();
      //  this.onChangeTable(this.config);
    }

    public changePage(page: any, data: Array<Model> = this.data): Array<Model> {
        const start = (page.page - 1) * page.itemsPerPage;
        const end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
        return data.slice(start, end);
    }

    public changeSort(data: Array<Model>, config: any): Array<Model> {
        if (!config ||!config.sorting) {
            return data;
        }

        const columns = this.config.sorting.columns || [];
        let columnName: string = void 0;
        let sort: string = void 0;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            let property = current[columnName];
            let prevProp = previous[columnName];
            if (property !== null && typeof property === 'object' && property.hasOwnProperty('name')) {
                property = property.name;
                prevProp = prevProp.name;
            }
            if (prevProp > property) {
                return sort === 'desc' ? -1 : 1;
            } else if (prevProp < property) {
                return sort === 'asc' ? -1 : 1;
            }
            return 0;
        });
    }

    public changeFilter(data: Array<Model>, config: any): Array<Model> {
        let filteredData: Array<any> = data;
        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    var property = item[column.name];
                    if (property !== null && typeof property === 'object' && property.hasOwnProperty('name')) {
                        property = property.name;
                    }
                    if (typeof property == 'string') {
                        property = property.toLowerCase();
                        let filter = column.filtering.filterString.toLowerCase();
                        return property.match(filter);
                    }
                    return true;
                    
                });
            }
        });

        if (!config || !config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: Model) => {
                item[config.filtering.columnName].match(this.config.filtering.filterString);
            });
        }

        const tempArray: Array<any> = [];
        filteredData.forEach((item: Model) => {
            let flag = false;
            this.columns.forEach((column: any) => {
                let columnName = item[column.name].toString().toLowerCase();
                let filter = this.config.filtering.filterString.toLowerCase();
                if (columnName.match(filter)) {
                    flag = true;
                }
            });
            if (flag) {
                tempArray.push(item);
            }
        });
        filteredData = tempArray;

        return filteredData;
    }

    public applyPipes(data: Array<Model>): Array<Model> {
        let pipedData: Array<any> = JSON.parse(JSON.stringify(data));

        this.columns.forEach((column: any) => {
            if (column.pipe && column.pipe.includes('date')) {                
                pipedData.map(singleEntry => {
                    let date = singleEntry[column.name];
                    let pipedDate;
                    if(column.pipe === 'dateTime') {
                        pipedDate = this.datePipe.transform(new Date(date), 'dd.MM.yyyy HH:mm')
                    }
                    if (column.pipe === 'date') {
                        pipedDate = this.datePipe.transform(new Date(date), 'dd.MM.yyyy')
                    }
                    return singleEntry[column.name] = pipedDate;
                })
            }
        });
        return pipedData;
    }

    public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }) {
        if (config) {
            if (config.filtering) {
                Object.assign(this.config.filtering, config.filtering);
            }
    
            if (config.sorting) {
                Object.assign(this.config.sorting, config.sorting);
            }
        }

        const pipedData = this.applyPipes(this.data);
        const filteredData = this.changeFilter(pipedData, this.config);
        const sortedData = this.changeSort(filteredData, this.config);
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

    public onCellClick(data: any): any {
        if (data.row.hasOwnProperty('userId')) {
            this.router.navigate(['/user/detail', data.row.userId]);
        }
        if (data.row.hasOwnProperty('publisherId')) {
            this.router.navigate(['/publisher/detail', data.row.publisherId]);
        }
        if (data.row.hasOwnProperty('mediaId')) {
            this.router.navigate(['/media/detail', data.row.mediaId]);
        }
        if (data.row.hasOwnProperty('versionId')) {
            this.router.navigate(['/version/detail', data.row.versionId]);
        }
        if (data.row.hasOwnProperty('organisationUnitId')) {
            window.open('./GrafischeEntwicklung/mrge.html?id=' + data.row.organisationUnitId
                + '&jwt=Bearer ' + localStorage.getItem('token'), '_blank');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/tableTemplate/table.template.component.ts